import React, { Component } from 'react'
import { object, array } from 'prop-types'
import Form from '../ContactForm/ContactForm'
import { withContext } from '../../../utils/withContext'

import styles from './End.styl'

class End extends Component {

	static propTypes = {
		context: object,
		contacts: array
	}

	render() {
		const { context: { i18n }, contacts } = this.props
		const contactMethod = (contacts || []).map((contact, index) => <small key={ index }><strong>{ contact.label }:</strong> { contact.value }</small>)
		return (
			<section id="contacts" className={ styles['section'] }>
				<div className={ styles['content'] }>
					<div className={ styles['details-container'] }>
						<h3>{ i18n`contacts_banner_title_label` }</h3>
						<h2>{ i18n`contacts_banner_subtitle_label_1` }</h2>
						<h2>{ i18n`contacts_banner_subtitle_label_2` }</h2>
					</div>
					<div className={ styles['contact-row'] }>
						<div className={ styles['text-col'] }>
							<h2>{ i18n`contacts_title_label` }</h2>
							<small>{ i18n`contacts_subtitle_label` }</small>
						</div>
						<div className={ styles['contact-col'] }>
							{ contactMethod }
						</div>
						<div className={ styles['social-col'] }>
							<h3>{ i18n`social_media_label` }</h3>
							<ul className={ styles.mediaUl }>
								<li>
									<a href={ 'https://www.facebook.com/beAPTbypaulopires/' }>
										<svg className={ styles.social_icon } height="24" viewBox="0 0 510 510" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M459 0H51C22.95 0 0 22.95 0 51v408c0 28.05 22.95 51 51 51h408c28.05 0 51-22.95 51-51V51c0-28.05-22.95-51-51-51zm-25.5 51v76.5h-51c-15.3 0-25.5 10.2-25.5 25.5v51h76.5v76.5H357V459h-76.5V280.5h-51V204h51v-63.75C280.5 91.8 321.3 51 369.75 51h63.75z" fill="#fff" /></svg>
									</a>
								</li>
								<li>
									<a href={ 'https://www.instagram.com/beapt_bypaulopires/' }>
										<svg className={ styles.social_icon } height="24" viewBox="0 0 438.536 438.536" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M421.98 16.562C410.94 5.52 397.71 0 382.3 0H56.248C40.83 0 27.604 5.52 16.56 16.562 5.52 27.6 0 40.828 0 56.242V382.29c0 15.413 5.52 28.644 16.56 39.683 11.044 11.04 24.273 16.563 39.688 16.563h326.046c15.41 0 28.644-5.523 39.684-16.563 11.043-11.04 16.557-24.27 16.557-39.683V56.243c0-15.418-5.514-28.64-16.554-39.68zM157.463 158.025c17.224-16.652 37.924-24.982 62.097-24.982 24.36 0 45.152 8.33 62.38 24.982 17.228 16.655 25.837 36.785 25.837 60.386 0 23.6-8.61 43.73-25.837 60.38-17.228 16.66-38.014 24.988-62.38 24.988-24.173 0-44.87-8.336-62.098-24.988s-25.84-36.78-25.84-60.38 8.612-43.73 25.84-60.385zM388.865 370.59c0 4.944-1.718 9.082-5.14 12.415-3.434 3.33-7.52 4.996-12.283 4.996h-305.2c-4.948 0-9.09-1.665-12.42-4.995-3.332-3.326-4.997-7.47-4.997-12.416V185.574H89.08c-3.805 11.993-5.708 24.462-5.708 37.402 0 36.553 13.322 67.715 39.97 93.51 26.65 25.787 58.72 38.686 96.216 38.686 24.744 0 47.583-5.903 68.527-17.703 20.937-11.807 37.486-27.84 49.676-48.112 12.184-20.272 18.275-42.4 18.275-66.38 0-12.94-1.91-25.406-5.715-37.402h38.547V370.59h-.002zm0-254.964c0 5.52-1.903 10.184-5.716 13.99-3.806 3.81-8.467 5.71-13.99 5.71h-49.676c-5.517 0-10.185-1.902-13.99-5.71-3.806-3.806-5.708-8.47-5.708-13.99V68.522c0-5.33 1.902-9.945 5.708-13.848 3.806-3.9 8.474-5.854 13.99-5.854h49.676c5.523 0 10.185 1.952 13.99 5.854 3.81 3.903 5.715 8.518 5.715 13.848v47.104z" fill="#fff" /></svg>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<Form />
				</div>
			</section >
		)
	}
}

export default withContext(End)



// WEBPACK FOOTER //
// ./src/client/website/components/End/End.js